import React from "react";
import { Link } from "react-router-dom";
import mail from "../../images/icon/mail.png";
import payment from "../../images/logo_card.png";
import OfferFeaturesSection from "../OfferFeaturesSection/OfferFeaturesSection";
import Logo from "../UiStyle/Logo";
import Discountbar from "../Discountbar/Discountbar";
import HeaderTopbar from "../HeaderTopbar/HeaderTopbar";
import { connect } from "react-redux";
import instagramIcon from "../../images/insta_web.png";
import twitterIcon from "../../images/facebook_web.png";
import pinterestIcon from "../../images/youtube_web.png";
import mcafeeIcon from "../../images/godday_web.png";
import godaddyIcon from "../../images/ssl_secure_web.png";
import copyscapeIcon from "../../images/trust_pilot_web.png";
import linkedinIcon from "../../images/linkedin_web.png";
import OrderNotificationsPopUp from "../OrderNotificationsPopUp";
import "../UiStyle/FooterStyles.css";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const SubmitHandler = (e) => {
  e.preventDefault();
};

const Footer = (props) => {
  const { configs } = props;
  const email_support = configs?.admin_conditions?.email_support || "";
  return (
    <>
      {/* <Discountbar /> */}
      <HeaderTopbar />
      <OrderNotificationsPopUp />
      <footer className={`footer-section ${props.ftClass}`}>
        <div className="upper-footer">
          <div className="container">
            <div className="row">
              {/* Column 1: Information */}
              <div className="col-md-3 col-sm-6">
                <div className="widget link-widget">
                  <h5 className="widget-title text-white">CHEMIST FOR ALL</h5>
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    {/* <li>
                      <Link to="/sitemap.xml">Site Map</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/contact">Contact Us</Link>
                    </li> */}
                    <li>
                      <Link to="/terms-and-condition">
                        Terms and Conditions
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                    {/* <li>
                      <Link to="/how-to-order">How to Place the Order</Link>
                    </li> */}
                  </ul>
                </div>
              </div>

              {/* Column 2: Articles & Policies */}
              <div className="col-md-3 col-sm-6" style={{ marginTop: window.innerWidth <= 767 ? 24 : 0 }}>
                <div className="widget link-widget">
                  <h5 className="widget-title text-white">MORE</h5>
                  <ul>
                    {/* <li>
                      <Link to="/articles">Articles</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/know-indian-pharmacy">
                        Know about Generic Medicines
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to="/click-to-call">Chat us on Whats app</Link>
                    </li> */}
                    <li>
                      <Link to="/cancellation-refund-policy">
                        Cancellation Policy
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/returns">Refunds and Returns</Link>
                    </li> */}
                    <li>
                      <Link to="/drug-policy">Drug Policy</Link>
                    </li>
                    <li>
                      <Link to="/blogs">
                       Blogs
                      </Link>
                    </li>
                    <li>
                      <Link to="/about#indian-pharmacies">
                       Indian Pharmacy
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/anti-spam-policy">AntiSpam Policy</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/blog">Blog</Link>
                    </li> */}
                  </ul>
                </div>
              </div>

              {/* Column 3: Category */}
              <div className="col-md-3 col-sm-6" style={{ marginTop: window.innerWidth <= 767 ? 24 : 0 }}>
                <div className="widget link-widget">
                  <h5 className="widget-title text-white">CATEGORY</h5>
                  <ul>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Pain+Relief">
                        New Products
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Beauty+%26+Skin+Care">
                        Featured Products
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Antibiotics">
                        Multi Vitamin
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Female+Infertlity">
                        Women's Health
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Pain+Relief">
                        Pain Relief
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Column 4: Top Category & Social */}
              <div className="col-md-3 col-sm-6" style={{ marginTop: window.innerWidth <= 767 ? 24 : 0 }}>
                <div className="widget link-widget">
                  <h5 className="widget-title text-white">TOP CATEGORY</h5>
                  <ul>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Men%27s+Health">
                        Men's Health
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Asthma">
                        Asthma
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Eye+Care">
                        Eye Care
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Diabetes">
                        Diabetes
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Acne">
                        Acne
                      </Link>
                    </li>
                    <li>
                      <Link to="https://www.chemistforall.com/shop?category=Beauty+%26+Skin+Care">
                        Beauty & Skin Care
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="social-widget mt-3">
                  <h6 className="widget-title text-white">FOLLOW US</h6>
                  <div
                    className="social-icons"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    <a
                      href="https://www.instagram.com/chemistforall/"
                      target="_blank"
                    >
                      <img
                        src={instagramIcon}
                        alt="Instagram"
                        style={{ width: 30 }}
                      />
                    </a>
                    <a
                      href="https://www.facebook.com/profile.php?id=61574024820827"
                      target="_blank"
                    >
                      <img
                        src={twitterIcon}
                        alt="Twitter"
                        style={{ width: 30 }}
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/@Chemistforall"
                      target="_blank"
                    >
                      <img
                        src={pinterestIcon}
                        alt="Pinterest"
                        style={{ width: 30 }}
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/chemistforall/"
                      target="_blank"
                    >
                      <img
                        src={linkedinIcon}
                        alt="Pinterest"
                        style={{ width: 30 }}
                      />
                    </a>
                  </div>
                  <p>For any queries or inquiries, Contact us at: <a href={`mailto:support@chemistforall.com`} style={{ color: "#F3A952" }}>support@chemistforall.com</a></p>
                </div>
              </div>
            </div>

            {/* Trust Badges */}
            <div className="row text-center my-4">
              <div className="col" style={{ display: "flex", gap: "10px" }}>
                <img
                  src={mcafeeIcon}
                  alt="McAfee"
                  className=""
                  style={{ width: 110 }}
                />
                <img
                  src={godaddyIcon}
                  alt="GoDaddy"
                  className=""
                  style={{ width: 110 }}
                />
                <img
                  src={copyscapeIcon}
                  alt="Copyscape"
                  className=""
                  style={{ width: 110 }}
                />
              </div>
            </div>

            {/* Disclaimer */}
            <div className="row">
              <div className="col">
                <p className="disclaimer-text meadium">
                  Please note that not all medications listed on our website are
                  dispensed exclusively from our affiliated pharmacy in India.
                  Your order may be processed and shipped from an approved
                  international fulfillment center located in a country outside
                  of India. We partner with licensed and regulated fulfillment
                  centers across the globe, including but not limited to India,
                  New Zealand, the United Kingdom, and the United States.
                  Depending on availability and regulatory requirements, your
                  medications may be sourced and dispatched from any of these
                  locations. All affiliated fulfillment centers comply with the
                  regulations of their respective national health authorities to
                  ensure product safety and quality.
                </p>
              </div>
            </div>
          </div> 
        </div>

        <div className="lower-footer">
          <div className="container">
            <div className="row justify-content-between align-items-center">
              {/* Left side - Copyright */}
              <div className="col-auto">
                <p className="copyright m-0">
                  COPYRIGHT © 2025 CHEMISTFORALL. ALL RIGHTS RESERVED. 
                </p>
              </div>

              {/* Right side - Payment icons */}
              <div className="col-auto master-card-logo">
                <img
                  src={payment}
                  alt="visa-master-card"
                  style={{ width: 90 }}
                />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
    w_list: state.wishList.w_list,
    configs: state.configs,
  };
};
export default connect(mapStateToProps)(Footer);